import { render, staticRenderFns } from "./ModalRemuneracaoSuporteHospital.vue?vue&type=template&id=73e9e3d3&scoped=true"
import script from "./ModalRemuneracaoSuporteHospital.vue?vue&type=script&lang=ts"
export * from "./ModalRemuneracaoSuporteHospital.vue?vue&type=script&lang=ts"
import style0 from "./ModalRemuneracaoSuporteHospital.vue?vue&type=style&index=0&id=73e9e3d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e9e3d3",
  null
  
)

export default component.exports